module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-book"
    }
  }, [_c('h1', [_vm._v("About the Book")]), _vm._v(" "), _c('p', [_vm._v("Follow the paths of two artists, Alexander Wainwright and Rinaldo, in a passionate, suspenseful tale of art, life, love, and liberation. For such different men in their art and personalities, the fundamental question is whether they can ever collaborate on a project.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72eaecfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0